import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero';
import AppointmentSection from '../../components/AppointmentSection/AppointmentSection';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import About from '../../components/about/about';
import ProcessSection from '../../components/ProcessSection/ProcessSection';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import CtaSection from '../../components/CtaSection/CtaSection';
import TeamSection from '../../components/TeamSection/TeamSection';
import FunFact from '../../components/FunFact/FunFact';
import BlogSection from '../../components/BlogSection/BlogSection';
import CtafromSection from '../../components/CtafromSection/CtafromSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/Horizontal-Logo-color.png'

const HomePage = () => {
    const SITE_URL = 'https://pharmacyfreedomfund.com';
    const schema = [
        {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` },
                { "@type": "ListItem", "position": 2, "name": "For Investors", "item": `${SITE_URL}/for-investors` }
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "For Investors",
            "url": `${SITE_URL}/for-investors`
        }
    ];
    return (
        <Fragment>
            <SEO
                title="For Investors"
                description="Discover recession-resistant pharmacy investments. Pharmacy Freedom Fund curates and operates high-potential pharmacies for stable, impact-driven returns."
                keywords={["pharmacy investment", "impact investing", "healthcare investing", "recession resistant", "Pharmacy Freedom Fund"]}
                canonical="https://pharmacyfreedomfund.com/for-investors"
                schema={schema}
            />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <Hero hclass={'static-hero'} />
            <ServiceSection hclass={"service_section section-padding"} />
            <About hclass={'about_section section-padding'} />
            <ProcessSection hclass={"work_section section-padding"} />
            <ProjectSection hclass={'project_section section-padding'} />
            <Testimonial tClass={'testimonial_section testimonial_section_slider'} />
            <FunFact hclass={'funfact_section'} />
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage;